// 操作卓　車両ボタン、映像切替ボタン押下
// 監視→車両：VideoPat_Com
export function videoMixPat(sr: string, dt: string, videoPat: number) {
  let obj = {
    cd: "VideoPat_Com", // コマンド種別(元：Video_MixPat)
    sr: sr, // 送信元
    dt: dt, // 送信先
    st: {
      video_pat: Number(videoPat), // 映像切り替えパターン
    },
  };
  return obj;
}

// 操作卓　車両切替ボタン押下
// 監視→車両：SelectCar_Com:送信制御指示
export function vehicleChangeSelectCar(
  sr: string,
  dt: string,
  ctr: number
) {
  let obj = {
    cd: "SelectCar_Com",
    sr: sr, // 送信元
    dt: dt, // 送信先
    st: {
      ctr: ctr, // 制御状態
    },
  };
  return obj;
}

// 操作卓　車両切替ボタン押下
// 監視車両切替
export function sendChangeCar(
  sr: string,
  dt: string,
  pos: number,
  vid: string | null
) {
  let obj = {
    cd: "LayoutCar_Com", // 元：Comm_Ctl：5
    sr: sr, // 送信元
    dt: dt, // 送信先
    st: {
      pos: Number(pos),
      vid: vid,
    },
  };
  return obj;
}

// 操作卓　音声切替ボタン押下
// 監視→車両：Audio_Mix
export function audioMix(sr: string, dt: string, mic: number, spk: number) {
  let obj = {
    cd: "AudioMix_Com", // 元：Audio_Mix
    sr: sr, // 送信元
    dt: dt, // 送信先
    st: {
      mic: Number(mic), // マイク切り替え指示
      spk: Number(spk), // スピーカー切り替え指示
    },
  };
  return obj;
}

// 操作卓　確認ボタン押下
// 監視→車両：Int_Request
export function intRequest(sr: string, dt: string, anst1: string, anst2: string) {
  let obj = {
    cd: "Int_Request",
    sr: sr, // 送信元
    dt: dt, // 送信先
    st: {
      anst1: anst1,
      anst2: anst2,
    },
  };
  return obj;
}

// 操作卓　再生ボタン押下
// 監視→車両：Audio_Preset_Play
export function audioPresetPlay(
  sr: string,
  dt: string,
  psa: number,
  pri: number,
  vol: number,
  dev: number,
  tims: number
) {
  let obj = {
    cd: "AudioPresetPlay_Com", // 元：Audio_Preset_Play
    sr: sr, // 送信元
    dt: dt, // 送信先
    st: {
      psa: Number(psa), // Preset Audio Number
      pri: Number(pri), // 優先度
      vol: Number(vol), // 音量
      dev: Number(dev), // 再生スピーカー(車内/外)
      tims: Number(tims), // 再生回数
    },
  };
  return obj;
}

// 操作卓　監視終了ボタン押下
// 操作卓→各車両：SaveLog_Com
export function sendLogSave(sr: string, dt: string, tgt: number) {
  let obj = {
    cd: "SaveLog_Com", // 元：Save_Log
    sr: sr, // 送信元
    dt: dt, // 送信先
    st: {
      tgt: Number(tgt), // save log Target
    },
  };
  return obj;
}

// 操作卓　監視終了ボタン押下
// 操作卓→操作卓：Ope_Log
export function sendOperationCommand(sr: string, dt: string, ope: string) {
  let obj = {
    cd: "YMCOpe_Log", // 元：Ope_Log
    sr: sr, // 送信元
    dt: dt, // 送信先
    st: {
      ope: ope, // 操作コマンド
    },
  };
  return obj;
}

// 操作卓　ガイド線指示
// 監視→監視：Update_Screen
export function sendUpdateScreen(
  sr: string,
  dt: string,
  cmd: number,
  vid: string,
  prm: number,
  gi: number
) {
  let obj = {
    cd: "UpdateScreen_Com",
    sr: sr, // 送信元
    dt: dt, // 送信先
    st: {
      cmd: cmd, // コマンド
      vid: vid, // 車両ID
      prm: prm, // メッセージID
      gi: gi, // ガイドパターン
    },
  };
  return obj;
}

// 1車両　音声死活監視
// 1車両→ロビー：Audio_HealthCheck_Info
export function sendAliveOnevehicleToLobby(
  sr: string,
  dt: string,
  aud: number,
  vid: string
) {
  let obj = {
    cd: "Audio_HealthCheck_Info", // 元：HealthCheck_Ctl
    sr: sr, // 送信元
    dt: dt, // 送信先
    st: {
      aud: aud,  // 0:音声不通, 1:正常
      vid: vid,  // 車両番号
    },
  };
  return obj;
}
